'use client';

import { use } from 'react';
import { AuthContext, type AuthContextValue } from '@/contexts/AuthContext';

/**
 * Хук для доступа к контексту аутентификации.
 *
 * Использование:
 *   const { user, login, logout, isAuthenticated } = useAuth();
 *
 * Должен использоваться только внутри <AuthProvider>.
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);

  if (!context) {
    throw new Error(
      'useAuth() должен вызываться внутри <AuthProvider>. ' +
      'Убедитесь, что AuthProvider оборачивает ваше приложение в layout.tsx'
    );
  }

  return context;
}
